import { AnalyticsEvent } from './client';

export const EVENTS_FOR_SECONDARY_COUNTER = new Set([
  AnalyticsEvent.paymentSuccess,
  AnalyticsEvent.paymentSuccessFirst,
  AnalyticsEvent.authCabinetCreationOk
]);
